let customizeProNameStr = process.env.VUE_APP_CUSTOMIZEPRONAMEARR
let customizeProNameArr = []
if (customizeProNameArr && customizeProNameStr.indexOf(',') > -1) {
  customizeProNameArr = customizeProNameStr.split(',')
}

console.debug('VUE_APP_CUSTOMIZEPRONAMEARR:', customizeProNameArr)

export default customizeProNameArr
